<template>
  <div id="tab4" class="tab active">
    <!--    <Popup v-if="selectedImage" :image="selectedImage"></Popup>-->
    <isotope
      :list="list"
      id="root_isotope"
      class="isoDefault"
      :options="option"
    >
      <div
        v-for="(item, index) in list"
        :key="index"
        :class="item.extra"
        :style="{ 'background-color': item.color }"
      >
        <a @click="selectedImage = item.original">
          <img :src="item.image" />
        </a>
      </div>
    </isotope>
    <hire />
  </div>
</template>

<script>
import isotope from "vueisotope";

export default {
  components: { isotope },
  data() {
    return {
      selectedImage: "",
      list: [
        // {
        //   image: "/img/gallery/1.jpg",
        //   original: "/img/gallery/1.jpg",
        //   title: "Jadu",
        //   desc: "Jadu bhut bada",
        //   color: "#000"
        // },
        // {image: "/img/gallery/31.jpg", title: "Jadu", desc: "Jadu bhut bada", color: "#DACCC7"},
        // {image: "/img/gallery/3.jpg", title: "Jadu", desc: "Jadu bhut bada", color: "#4A4A4A"},
        // {image: "/img/gallery/4.jpg", title: "Jadu", desc: "Jadu bhut bada", color: "#9CB4BE"},
        {
          image: "/img/gallery/1-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#5b504a",
        },
        {
          image: "/img/gallery/59.gif",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#EE9F78",
        },
        {
          image: "/img/gallery/2-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#416170",
        },
        {
          image: "/img/gallery/3-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FBAC43",
        },
        {
          image: "/img/gallery/4-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#214248",
        },
        {
          image: "/img/gallery/5-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#110C10",
        },
        {
          image: "/img/gallery/6-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#DED4CB",
        },
        {
          image: "/img/gallery/7-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#4C3B67",
        },
        {
          image: "/img/gallery/8-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FFD4B1",
        },
        {
          image: "/img/gallery/9-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#E48A62",
        },
        {
          image: "/img/gallery/10-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#1B262C",
        },
        {
          image: "/img/gallery/11-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#D5C2C4",
        },
        {
          image: "/img/gallery/12-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#2A4C6F",
        },
        {
          image: "/img/gallery/13-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#9C8B68",
        },
        {
          image: "/img/gallery/14-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#282C2D",
        },
        {
          image: "/img/gallery/15-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#325671",
        },
        {
          image: "/img/gallery/16-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#1F262C",
        },
        {
          image: "/img/gallery/17-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#3e706d",
        },
        {
          image: "/img/gallery/18-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#17475B",
        },
        {
          image: "/img/gallery/19-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FBAC43",
        },
        {
          image: "/img/gallery/20-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#F9F0E7",
        },
        {
          image: "/img/gallery/21-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#684780",
        },
        {
          image: "/img/gallery/22-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#40797F",
        },
        {
          image: "/img/gallery/23-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#01292A",
        },
        {
          image: "/img/gallery/24-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#002A36",
        },
        {
          image: "/img/gallery/25-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#E4C3BA",
        },
        {
          image: "/img/gallery/26-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#AC6C4C",
        },
        {
          image: "/img/gallery/27-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#714334",
        },
        {
          image: "/img/gallery/28-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#202328",
        },
        {
          image: "/img/gallery/29-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#003442",
        },
        {
          image: "/img/gallery/30-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FAB880",
        },
        {
          image: "/img/gallery/31-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#D79678",
        },
        {
          image: "/img/gallery/32-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#4C3525",
        },
        {
          image: "/img/gallery/33-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#0E0905",
        },
        {
          image: "/img/gallery/34-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#2881A3",
        },
        {
          image: "/img/gallery/35-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FEB402",
        },
        {
          image: "/img/gallery/36-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#1B756F",
        },
        {
          image: "/img/gallery/37-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#01B4E5",
        },
        {
          image: "/img/gallery/38-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#433643",
        },
        {
          image: "/img/gallery/39-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#494D6F",
        },
        {
          image: "/img/gallery/40-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#6B4E4F",
        },
        {
          image: "/img/gallery/41-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#306972",
        },
        {
          image: "/img/gallery/42-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#575757",
        },
        {
          image: "/img/gallery/43-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#E0D6D5",
        },
        {
          image: "/img/gallery/44-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#666666",
        },
        {
          image: "/img/gallery/45-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#B3CAD2",
        },
        {
          image: "/img/gallery/46-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#D69B5F",
        },
        {
          image: "/img/gallery/47-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FDE7CC",
        },
        {
          image: "/img/gallery/48-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FDD2AF",
        },
        {
          image: "/img/gallery/49-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#E8E6E7",
        },
        {
          image: "/img/gallery/50-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FA8F31",
        },
        {
          image: "/img/gallery/51-min.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#8E8288",
        },

        //for extra size :-
        // ,extra: "item-2x"
      ],
      selected: null,
      option: {
        getSortData: {
          id: "id",
        },
        sortBy: "id",
      },
    };
  },
};
</script>
